










import { Component, Mixins } from 'vue-property-decorator'
import ListConditionSetupView
  from '@/components/TriggerSetup/components/ListConditionSetupView/ListConditionSetupView.vue'
import { ConditionSetupView } from '@/components/TriggerSetup/logic/mixins/condition-setup-view.mixin'
import RegexpConditionHelpMessage from '@/components/TriggerSetup/components/RegexpConditionHelpMessage.vue'

@Component({
  components: {
    RegexpConditionHelpMessage,
    ListConditionSetupView
  }
})
export default class MessagePhoneNumberEntityRegexpTypeSetupView extends Mixins<ConditionSetupView>(ConditionSetupView) {

}
